import script from "./LoginPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=1a33bac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a33bac0"]])

export default __exports__